// extracted by mini-css-extract-plugin
module.exports = {"spinner":"ListOfTasks_spinner__2SPw3","head":"ListOfTasks_head__1hP6a"};